import { render, staticRenderFns } from "./landingPage.vue?vue&type=template&id=8e2edba0&scoped=true&"
import script from "./landingPage.vue?vue&type=script&lang=js&"
export * from "./landingPage.vue?vue&type=script&lang=js&"
import style0 from "./landingPage.scss?vue&type=style&index=0&id=8e2edba0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2edba0",
  null
  
)

export default component.exports